import { defineComponent as _defineComponent } from 'vue'
import MyProjectsSectionHeader from '@/views/my-projects/components/MyProjectsSectionHeader.vue';
import {
  computed, PropType, ref
} from 'vue';
import { useArrayFilter } from '@vueuse/core';
import { BaseContract, Contract, ContractStatus } from '@/models/Contracts';
import MyProjectsContractTable from '@/views/my-projects/components/contracts/MyProjectsContractTable.vue';
import useI18n from '@/mixins/useI18n';
import BCXHelpTextTriggerIcon from '@/components/molecules/BCXHelpTextTriggerIcon.vue';
import BCXInfoCollapsible from '@/components/molecules/BCXInfoCollapsible.vue';
import useResponsiveness from '@/mixins/useResponsiveness';
import useContractOverview from '../../composables/useContractOverview';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsContractList',
  props: {
  type: {
    type: String as PropType<'open' | 'closed'>,
    default: 'open'
  }
},
  setup(__props) {

const props = __props;



const { t } = useI18n();
const { isMobileWidth } = useResponsiveness();
const { allContracts } = useContractOverview();
const isOpenType = computed(() => props.type === 'open');
const isHelpOpen = ref(false);

const states = computed(() => (isOpenType.value ? [
  ContractStatus.Open, ContractStatus.Canceled
] : [
  ContractStatus.Signed, ContractStatus.Ended
]));

const contracts = useArrayFilter(allContracts, (contract: Contract) => states.value.includes(contract.status));

const filter = computed(() => ({
  style: 'dropdown',
  isExclusive: false,
  states: states.value,
  stateCallback: (states: string[], obj: BaseContract) => states.includes(obj.status),
  labelCallback: (state: string) => `${t(`contracts.status.${state}`)}`
}));


return { __sfc: true,props, t, isMobileWidth, allContracts, isOpenType, isHelpOpen, states, contracts, filter, MyProjectsSectionHeader, MyProjectsContractTable, BCXHelpTextTriggerIcon, BCXInfoCollapsible }
}

})